import React from 'react';
import PropTypes from 'prop-types';
import Intercom from 'react-intercom';
import { IntercomAPI, INTERCOM_ENABLED } from '~/config';

function PxIntercom({ session }) {
	if( !INTERCOM_ENABLED ) {
		return null;
	}

	const user = {
		user_id: session._id,
		email: session.emailNormal,
		created: Math.round(new Date().getTime() / 1000)
	};

	return (
		<Intercom appID={IntercomAPI} { ...user } />
	);
}

PxIntercom.propTypes = {
	session: PropTypes.object.isRequired
};

export default PxIntercom;
